<div class="row mt-4 me-5 pt-5 pb-5 align-items-center rounded-3 border shadow-lg content-container">
    
    <div class="buttons-holder col-5 offset-1 mt-0 mb-2">
        <button type="button" class="btn btn-success" (click)="createNewFamily()">
            <i class="bi bi-person-plus"></i><span class="add-family-label">Inviter une nouvelle famille</span>
        </button>
    </div>

    <div class="buttons-holder offset-2 col-4 mt-0 mb-2">
        <button type="button" class="btn btn-black" (click)="openGenerateInvitationsModal()">
            <i class="bi bi-envelope-open-heart"></i><span class="add-family-label">Telecharger les Fair-parts</span>
        </button>
    </div>

    <div class="filters col-12 mb-2 ps-3 pe-3">
        <div class="form-floating">
            <select class="form-select select-filter" id="responseFilter" aria-label="Floating label select"
                [formField]="responseFilterForm">
                @for (option of [attendingStatusEmpty, ...attendingStatusOptions]; track option.getKey()) {
                <option [selected]="responseFilter() === option.getKey()"
                    [disabled]="responseFilter() === option.getKey()" [value]="option.getKey()">
                    {{ option.getValue() }}
                </option>
                }
            </select>
            <label for="responseFilter">Participation :</label>
        </div>
        <div class="form-floating">
            <select class="form-select select-filter" id="invitationTypeFilter" aria-label="Floating label select"
                [formField]="invitationTypeFilterForm">
                @for (option of invitationTypesOptions; track option.getKey()) {
                <option [selected]="invitationTypeFilter() === option.getKey()"
                    [disabled]="invitationTypeFilter() === option.getKey()" [value]="option.getKey()">
                    {{ option.getValue() }}
                </option>
                }
            </select>
            <label for="invitationTypeFilter">Type d'invitation :</label>
        </div>
        <div class="form-floating">
            <select class="form-select select-filter" id="coupleFilter" aria-label="Floating label select"
                [formField]="canInviteCoupleFilterForm">
                @for (option of booleanFilterOptions; track option.key) {
                <option [selected]="canInviteCoupleFilter() === option.key"
                    [disabled]="canInviteCoupleFilter() === option.key" [value]="option.key">
                    {{ option.value }}
                </option>
                }
            </select>
            <label for="coupleFilter">Peut inviter conjoint :</label>
        </div>
        <div class="form-floating">
            <select class="form-select select-filter" id="childrenFilter" aria-label="Floating label select"
                [formField]="canInviteChildrenFilterForm">
                @for (option of booleanFilterOptions; track option.key) {
                <option [selected]="canInviteChildrenFilter() === option.key"
                    [disabled]="canInviteChildrenFilter() === option.key" [value]="option.key">
                    {{ option.value }}
                </option>
                }
            </select>
            <label for="childrenFilter">Peut inviter enfants :</label>
        </div>
        <div class="form-floating">
            <select class="form-select select-filter" id="brunchFilter" aria-label="Floating label select"
                [formField]="staysAtBrunchFilterForm">
                @for (option of booleanFilterOptions; track option.key) {
                <option [selected]="staysAtBrunchFilter() === option.key" [disabled]="staysAtBrunchFilter() === option.key"
                    [value]="option.key">
                    {{ option.value }}
                </option>
                }
            </select>
            <label for="brunchFilter">Est présent au brunch :</label>
        </div>
        <div class="form-floating">
            <select class="form-select select-filter" id="adultFilter" aria-label="Floating label select"
                [formField]="isAdultFilterForm">
                @for (option of booleanFilterOptions; track option.key) {
                <option [selected]="isAdultFilter() === option.key" [disabled]="isAdultFilter() === option.key"
                    [value]="option.key">
                    {{ option.value }}
                </option>
                }
            </select>
            <label for="adultFilter">Est adulte :</label>
        </div>
        <div class="reset-btn">
            <button type="button" class="btn btn-outline-secondary" (click)="resetFilters()">
                <i class="bi bi-arrow-counterclockwise"></i>
            </button>
        </div>
    </div>
    <div class="filters col-12 mb-4 ps-3 pe-3">
        <div class="input-group">
            <span class="input-group-text" id="basic-addon1"><i class="bi bi-search-heart"></i></span>
            <input type="text" class="form-control" placeholder="Rechercher..." aria-label="Rechercher"
                aria-describedby="basic-addon1" id="filterQuery" [formField]="queryFilterForm">
        </div>
    </div>
    <div class="col-12 ps-3 pe-3 table-responsive">
        <table class="table align-middle">
            <thead class="table-light">
                <tr>
                    <th scope="col" class="header-clickable" (click)="updateSort('lastName')">
                        Nom 
                        <i class="bi header-sort" [style.visibility]="datatableActiveSort().field === 'lastName' ? 'visible' : 'hidden'"
                        [class]="datatableActiveSort().order === 'ASC' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"
                        ></i>
                    </th>
                    <th scope="col" class="header-clickable" (click)="updateSort('firstName')">
                        Prenom 
                        <i class="bi header-sort" [style.visibility]="datatableActiveSort().field === 'firstName' ? 'visible' : 'hidden'"
                        [class]="datatableActiveSort().order === 'ASC' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"
                        ></i>
                    </th>
                    <th scope="col" class="header-clickable" (click)="updateSort('familyDepartement')">
                        Departement 
                        <i class="bi header-sort" 
                        [style.visibility]="datatableActiveSort().field === 'familyDepartement' ? 'visible' : 'hidden'"
                        [class]="datatableActiveSort().order === 'ASC' ? 'bi-caret-down-fill' : 'bi-caret-up-fill'"
                        ></i>
                    </th>
                    <th scope="col">Reponse</th>
                    <th scope="col">Type d'invitation</th>
                    <th scope="col">Invite couple</th>
                    <th scope="col">Invite enfant(s)</th>
                    <th scope="col">Présent au brunch</th>
                    <th scope="col">Est adulte</th>
                    <th scope="col">Détail RSVP</th>
                </tr>
            </thead>
            <tbody class="table-group-divider">
                @for (inviteData of inviteDataModel(); track $index) {
                <tr>
                    <td><span class="centered-cell">{{inviteData.lastName}}</span></td>
                    <td><span class="centered-cell">{{inviteData.firstName}}</span></td>
                    <td><span class="centered-cell">{{inviteData.familyDepartement}}</span></td>
                    <td>
                        <i class="bi"
                            [class]="(inviteData.attendingStatus | attendingIcon: 'key') + ' ' + inviteData.attendingStatus"></i>
                        <select class="form-select" [class]="inviteData.attendingStatus"
                            [id]="'responseSelect' + inviteData.familyId" aria-label="Floating label select" (change)="updateFamilyResponse(inviteData.familyId, $event)">
                            @for (option of attendingStatusOptions; track option.getKey()) {
                            <option [selected]="inviteData.attendingStatus === option.getKey()"
                                [value]="option.getValue()" [disabled]="inviteData.attendingStatus === option.getKey()">
                                {{ option.getValue() }}
                            </option>
                            }
                        </select>
                    </td>
                    <td>
                        <i class="bi"
                            [class]="(inviteData.invitationType | invitationTypeIcon: 'key') + ' ' + inviteData.invitationType"></i>
                        <span class="invitation-label">{{inviteData.invitationType}}</span>
                    </td>
                    <td>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch"
                                [checked]="inviteData.canRequireCoupleInvite" (change)="updateRequireCoupleInvite(inviteData.familyId, $event)">
                        </div>
                    </td>
                    <td>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch"
                                [checked]="inviteData.canRequireChildsInvite" (change)="updateRequireChildsInvite(inviteData.familyId, $event)">
                        </div>
                    </td>
                    <td>
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch"
                                [checked]="inviteData.staysForBrunch" (change)="updateStaysForBrunch(inviteData.familyId, $event)">
                        </div>
                    </td>
                    <td>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" role="checkbox" disabled
                                [checked]="inviteData.adult">
                        </div>
                    </td>
                    <td>
                        <button type="button" class="btn btn-outline-primary" (click)="seeFamilyDetails(inviteData.familyId)">
                            Voir détails
                        </button>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>